import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { useStyles } from '../../../../common/hooks/useStyles';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { getSeekBarProgressStyleObject } from './seekBarProgress.style';
import { adsDataSelector } from '../../../../common/store/selectors/adsData.selector';
import { css } from '../../../../common/styles/styles.utils';
import { getSeekBarProgressId } from '../../htmlElements/htmlElementsIdGetter';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';

interface SeekBarProgressComponentVariablesProps {
  isPositionChanged: boolean;
}

export const SeekBarProgress: FunctionComponent<SeekBarProgressComponentVariablesProps> = props => {
  const { isPositionChanged } = props;

  const currentVideoTimeFragment = useSelector(playerDataSelector.currentVideoTimeFragment);
  const currentVideoDuration = useSelector(playerDataSelector.currentVideoDuration);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const adCurrentTime = useSelector(adsDataSelector.adCurrentTime);
  const adDuration = useSelector(adsDataSelector.adDuration);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const brandingColor = useSelector(brandingDataSelector.brandingColor);

  const showAdControls = isVastAd && adBreak;
  const currentTime = showAdControls ? adCurrentTime : currentVideoTimeFragment;
  const currentDuration = showAdControls ? adDuration : currentVideoDuration;

  const styles = useStyles(getSeekBarProgressStyleObject, [currentTime, currentDuration, isPositionChanged, brandingColor]);
  const { seekBarProgressStyle } = styles;

  return (
    <div id={getSeekBarProgressId(playerUniqueId)} style={css(seekBarProgressStyle)} />
  );
};
